let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("898JX")).then(() => parcelRequire('6zVCW'));